export default theme => ({

  root: {
    padding: theme.spacing.unit * 4
  },

  actions: {
    marginTop: theme.spacing.unit
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/RegistrationForm.js